import errorMessagesBodyDo from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-body-do.png";
import errorMessagesBodyDont from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-body-dont.png";
import errorMessagesTrustDo from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-trust-do.png";
import errorMessagesTrustDont from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-trust-dont.png";
import errorMessagesEncourageDo from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-encourage-do.png";
import errorMessagesEncourageDont from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-encourage-dont.png";
import errorMessagesExpectationsDo from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-expectations-do.png";
import errorMessagesExpectationsDont from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-expectations-dont.png";
import errorMessagesBackupDo from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-backup-do.png";
import errorMessagesBackupDont from "../../../../src/pages/foundations/content/designing-messages/error-messages/_assets/error-messages-backup-dont.png";
import * as React from 'react';
export default {
  errorMessagesBodyDo,
  errorMessagesBodyDont,
  errorMessagesTrustDo,
  errorMessagesTrustDont,
  errorMessagesEncourageDo,
  errorMessagesEncourageDont,
  errorMessagesExpectationsDo,
  errorMessagesExpectationsDont,
  errorMessagesBackupDo,
  errorMessagesBackupDont,
  React
};